<ng-template #modalLG let-modal style="border-radius: 8px">
    <div class="p-2">
        <span class="size18"> <strong>{{ documentType }} </strong> / <span style="color: #134AD3">{{ refExterne }}</span> </span>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div style=" border-bottom: 1px solid #eee;"></div>
    <div class="">
        <div class=" modal-body" tabindex="0" ngbAutofocus style="padding: 0 54px 64px">
            <div *ngIf="isLoading" class="text-center p-4">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Chargement...</span>
                </div>
            </div>
            
            <div *ngIf="!isLoading">
                <div class="d-flex justify-content-between">
                    <div class="mt-3 d-flex">
                        <div class="calendar" >
                            <i data-feather="calendar" [size]="18"></i>
                        </div>
                        <div class="mx-2">
                            <span class="text-muted">{{ documentDate }}</span> <br>
                            <span class="text-black">Date</span>
                        </div>
                    </div>

                    <div class="mt-3 d-flex">
                        <div class="check" >
                            <i data-feather="check" [size]="18"></i>
                        </div>
                        <div class="mx-2">
                            <span class="text-vert">{{ documentStatut }}</span> <br>
                            <span class="text-black">Statut</span>
                        </div>
                    </div>

                    <div class="  ">
                        <div class="border-dashed rounded text-center total-box-black d-flex flex-column justify-content-center align-items-center">
                            <div class="mt-2 mb-1 text-primary fw-bold">
                                <div class="user">
                                <i data-feather="user" [size]="18"></i>
                                </div>
                            </div>
                            <p class="size15 text-black">{{ getFournisseurNom() }}</p>
                            </div>
                    </div>

                     <div class="  " style="margin-left: 16px;">
                        <div class="border-dashed rounded text-center total-box ">
                            <div class="mt-2 mb-1 text-primary fw-bold">
                             <strong class=" size20"> {{ netPayer }} TND </strong>
                            </div>
                            <p class="size15 text-black">Montant total</p>
                        </div>
                    </div>
                </div>

                <!-- Informations Fournisseur - Design original -->
                <div class="d-flex justify-content-between card" style="padding: 27px 24px; margin-top: 18px; margin-bottom: 18px;">
                    <table #table>
                        <thead class="custom-header">
                        <tr>
                            <th class="texte1NoMargin">Fournisseur <br> <p class="texte2">{{ getFournisseurNom() }}</p></th>
                            <th class="texte1">Adresse <br> <p class="texte2">{{ getFournisseurAddress() }}</p></th>
                            <th class="texte12">Téléphone <br> <p class="texte2">{{ getFournisseurTelephone() }}</p></th>
                        </tr>
                        </thead>
                    </table>
                </div>

                <!-- Onglets -->
                <div class="d-flex align-items-center gap-2 mt-2 mb-1" style="overflow-x: auto;">
                    <!-- Onglet Articles -->
                    <button 
                        type="button"
                        class="tab-button"
                        [class.tab-active]="activeTab === 'article'"
                        [class.tab-inactive]="activeTab !== 'article'"
                        (click)="setActiveTab('article')">
                        <i data-feather="user" [size]="16"></i>
                        <span>Articles</span>
                    </button>

                    <!-- Onglet Paiement -->
                    <button 
                        type="button"
                        class="tab-button"
                        [class.tab-active]="activeTab === 'paiement'"
                        [class.tab-inactive]="activeTab !== 'paiement'"
                        (click)="setActiveTab('paiement')">
                        <i data-feather="dollar-sign" [size]="16"></i>
                        <span>Paiement</span>
                    </button>

                    <!-- Onglet Documents Liés -->
                    <button 
                        type="button"
                        class="tab-button"
                        [class.tab-active]="activeTab === 'document-lies'"
                        [class.tab-inactive]="activeTab !== 'document-lies'"
                        (click)="setActiveTab('document-lies')">
                        <i data-feather="lock" [size]="16"></i>
                        <span>Documents Liés</span>
                    </button>
                </div>

                <!-- Contenu de l'onglet Articles -->
                <div *ngIf="activeTab === 'article'" class="tab-content">
                    <div>
                        <!-- Facture client : valeur unitaire (produit) + prix HT -->
                        <table *ngIf="documentType === 'Facture' || documentType === 'FACTURE'"
                               class="products-table w-full mx-1 mb-2">
                            <thead>
                            <tr>
                                <th>PRODUIT</th>
                                <th>QUANTITÉ</th>
                                <th>REMISE</th>
                                <th>VALEUR UNITAIRE</th>
                                <th>PRIX DE VENTE</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngIf="lignesDocument.length === 0">
                                <td colspan="5" class="text-center text-muted">Aucun article</td>
                            </tr>
                            <tr *ngFor="let ligne of lignesDocument">
                                <td>{{ ligne.libelle }}</td>
                                <td>{{ ligne.qnt }}</td>
                                <td>{{ ligne.remise }}</td>
                                <td>{{ getValeurUnitaire(ligne.product_id) != null ? (getValeurUnitaire(ligne.product_id) | number:'1.3-3') : '--' }} TND</td>
                                <td>{{ formatPrice(ligne.prix_ht) }} TND</td>
                            </tr>
                            </tbody>
                        </table>
                        <!-- Facture fournisseur : prix d'achat depuis lignes_document (prix_achat) -->
                        <table *ngIf="documentType === 'Facture fournisseur' || documentType === 'FACTURE FOURNISSEUR'"
                               class="products-table w-full mx-1 mb-2">
                            <thead>
                            <tr>
                                <th>PRODUIT</th>
                                <th>QUANTITÉ</th>
                                <th>REMISE</th>
                                <th>PRIX D'ACHAT</th>
                                <th>PRIX HT</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngIf="lignesDocument.length === 0">
                                <td colspan="5" class="text-center text-muted">Aucun article</td>
                            </tr>
                            <tr *ngFor="let ligne of lignesDocument">
                                <td>{{ ligne.libelle }}</td>
                                <td>{{ ligne.qnt }}</td>
                                <td>{{ ligne.remise }}</td>
                                <td>{{ displayPrixAchatLigne(ligne) }}</td>
                                <td>{{ formatPrice(ligne.prix_ht) }} TND</td>
                            </tr>
                            </tbody>
                        </table>
                        
                        <!-- Tableau par défaut pour les autres types de documents -->
                        <table *ngIf="documentType !== 'Facture' && documentType !== 'FACTURE' && documentType !== 'Facture fournisseur' && documentType !== 'FACTURE FOURNISSEUR'" 
                               class="styled-table w-full mx-1 mb-2">
                            <thead>
                            <tr>
                                <th>PRODUIT</th>
                                <th>QUANTITÉ</th>
                                <th>REMISE</th>
                                <th>PRIX D'ACHAT</th>
                                <th>PRIX DE VENTE</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngIf="lignesDocument.length === 0">
                                <td colspan="5" class="text-center text-muted">Aucun article</td>
                            </tr>
                            <tr *ngFor="let ligne of lignesDocument">
                                <td>{{ ligne.libelle }}</td>
                                <td>{{ ligne.qnt }}</td>
                                <td>{{ ligne.remise }}</td>
                                <td>{{ getValeurUnitaire(ligne.product_id) != null ? (getValeurUnitaire(ligne.product_id) | number:'1.3-3') : '--' }} TND</td>
                                <td>{{ formatPrice(ligne.prix_ht) }} TND</td>
                            </tr>
                            </tbody>
                        </table>


                    </div>

                    <div class="d-flex justify-content-between align-items-end mt-3">
                        <!-- Bouton Retenue à la source - Affiché uniquement pour FACTURE et FACTURE FOURNISSEUR avec retenue à la source -->
                        <div class="d-flex align-items-center">
                            <button
                                    *ngIf="hasRetenueSource && ( documentType === 'Facture fournisseur' || documentType === 'FACTURE FOURNISSEUR')"
                                    type="button"
                                    class="btn-retenue-source"
                                    (click)="generateRetenueSource()">
                                <i data-feather="file-text" [size]="18"></i>
                                <span>Retenue à la source</span>
                            </button>
                        </div>

                        <!-- Bénéfice total - Toujours affiché à droite -->
                        <div class="border-dashed rounded text-center benef-box">
                            <div class="mt-2 mb-1 benef-title">
                                <strong class="size20">  {{ calculateBenefice() }} TND</strong>
                            </div>
                            <p class="mb-1 size15">Bénéfice total</p>
                        </div>
                    </div>
                </div>

                <!-- Contenu de l'onglet Paiement -->
                <div *ngIf="activeTab === 'paiement'" class="tab-content">
                    <div class="mx-1">
                        <table class="styled-table w-full mb-2">
                            <thead>
                            <tr>
                                <th>DATE</th>
                                <th>MONTANT</th>
                                <th>MODE DE PAIEMENT</th>
                                <th>RÉFÉRENCE</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngIf="paiements.length === 0">
                                <td colspan="4" class="text-center text-muted">Aucun paiement enregistré</td>
                            </tr>
                            <tr *ngFor="let paiement of paiements">
                                <td>{{ formatDate(paiement.date) }}</td>
                                <td>{{ paiement.montant ? formatPrice(paiement.montant) : '--' }} TND</td>
                                <td>{{ paiement.mode_paiement || '--' }}</td>
                                <td>{{ paiement.reference || '--' }}</td>
                            </tr>
                            </tbody>
                        </table>
                        
                        <!-- Total des paiements -->
                        <div *ngIf="paiements.length > 0" class="d-flex justify-content-end mt-3">
                            <div class="border-dashed rounded text-center" style="min-width: 189px; height: 102px; border: 1px dashed #134AD3; padding: 10px;">
                                <div class="mt-2 mb-1 text-primary fw-bold">
                                    <strong class="size20">{{ calculateTotalPaiements() }} TND</strong>
                                </div>
                                <p class="mb-1 size15">Total payé</p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Contenu de l'onglet Documents Liés -->
                <div *ngIf="activeTab === 'document-lies'" class="tab-content">
                    <div class="mx-1">
                        <table class="styled-table w-full mb-2">
                            <thead>
                            <tr>
                                <th>TYPE</th>
                                <th>RÉFÉRENCE</th>
                                <th>DATE</th>
                                <th>MONTANT</th>
                                <th>STATUT</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngIf="documentsLies.length === 0">
                                <td colspan="5" class="text-center text-muted">Aucun document lié</td>
                            </tr>
                            <tr *ngFor="let doc of documentsLies">
                                <td>{{ doc.type || '--' }}</td>
                                <td>{{ doc.reference || '--' }}</td>
                                <td>{{ formatDate(doc.date) }}</td>
                                <td>{{ doc.montant ? formatPrice(doc.montant) : '--' }} TND</td>
                                <td>
                                    <span class="badge" 
                                          [class.badge-success]="doc.statut === 'Payé' || doc.statut === 'Payée' || doc.statut === 'Validé' || doc.statut === 'Validée'"
                                          [class.badge-warning]="doc.statut === 'En attente' || doc.statut === 'En cours'"
                                          [class.badge-info]="doc.statut === 'Crée' || doc.statut === 'Créé'"
                                          [class.badge-danger]="doc.statut === 'Annulé' || doc.statut === 'Annulée'"
                                          style="padding: 4px 8px; font-size: 12px;">
                                        {{ doc.statut || '--' }}
                                    </span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
